import { Component, OnInit, OnDestroy, ElementRef, AfterViewInit, Renderer, Input } from '@angular/core';
import * as ko from 'knockout';
import {
    NgForm,
    FormGroup,
    FormControl,
    FormArray,
    Validators,
    ValidatorFn,
    AsyncValidatorFn
} from '@angular/forms';
import { FormInlineRowComponent } from './../forms/form-inline-row';
import { MessageComponent, BaseComponent } from '../common/common-components';
import { DictionaryService } from "../services/dictionary-service";
import { MessageService } from "../services/message-service";
import { ViewportService } from "../services/viewport-service";
import { CurrencyRateService } from './currency-rate-service';
import {Observable} from 'rxjs';
import { RateWithRebate } from './model/rate-with-rebate';

let _: any = require("lodash");

@Component({
    selector: 'dk-currency-rates-table',
    template: require('./currency-rates-table.html'),
    entryComponents: [],
    providers: [CurrencyRateService]
})

export class CurrencyRatesTableComponent implements OnInit {
    rates: RateWithRebate[];
    errorMessage: string;
    loaded: boolean = false;
    currentPosition: number = 0;
    seconds: number;
    hasRebate: boolean = false;

    constructor(private currencyRateService: CurrencyRateService) {

    }

    ngOnInit() {
        this.getCurrencyRatesWithRebate();
    }

    getCurrencyRatesWithRebate() {
        if (CurrencyRateService.currentRates) {
            this.setRates(CurrencyRateService.currentRates);
        }

        this.currencyRateService.getCurrencyRatesSubject()
            .subscribe(
            r => {
                if (r) {
                    if ((typeof r === 'number')) {
                        this.seconds = r;
                    } else {
                        this.setRates(r);
                    }
                }
            },
            error => this.errorMessage = <any>error);
    }

    setRates(r) {
        this.rates = r;
        this.seconds = CurrencyRateService.refreshTime;
        this.loaded = true;
        if (r[0].buy == r[0].buyWithRebate) {
            this.hasRebate = false;
        } else {
            this.hasRebate = true;
        }
    }
}
